import { ModalComponents } from 'src/store/modal-components';
import { useModalStore } from 'src/store/modals';

export const ModalProvider = () => {
  const currentModalId = useModalStore((state) => state.modal);
  const CurrentModal = currentModalId ? ModalComponents[currentModalId] : null;
  return CurrentModal ? <CurrentModal /> : null;
};
